import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Transaction, TransactionMode } from './transaction.entity';
import { TransactionStatus } from './transaction.status.enum';

export class CreateTransactionDto extends Omit(Transaction, [...BaseEntityFieldsArray, 'status', 'mode'], ['status', 'mode']) {
    status?: TransactionStatus;
    mode?: TransactionMode;
}
